import { render, staticRenderFns } from "./RoomEmojis.vue?vue&type=template&id=285c9cd3&"
import script from "./RoomEmojis.vue?vue&type=script&lang=js&"
export * from "./RoomEmojis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports